import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

const CAMPAIGN_SEARCH = "search";

export const CampaignRoutes = {
    Campaign: "/campaign",
    CampaignHistorical: "/campaign/historical",
    Search: CAMPAIGN_SEARCH,
    SEARCH_MOBILE: CAMPAIGN_SEARCH,
} as const;

export const campaignRoutes = (
    <Route
        path={CampaignRoutes.Campaign}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { CampaignModuleLayout } =
                await import("@campaign/presentation/layout/campaign-module.layout.tsx");
            return { Component: CampaignModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { CampaignPage } =
                    await import("@campaign/presentation/pages/campaign/campaign.page.tsx");
                return { Component: CampaignPage };
            }}
        />
    </Route>
);
